import { Injectable } from "@angular/core";
import { Router } from "@angular/router";

@Injectable({
    providedIn: 'root'
})

export class LocalService {

    constructor(private router: Router,) {
    }

    get isLoggedIn(): boolean {
        let authToken = sessionStorage.getItem('fgh0x01b4#8');
        return (authToken !== null) ? true : false;
    }

    public logOut() {
        sessionStorage.clear();
        this.router.navigateByUrl("/login");
    }
}
